<template>
  <div>
    <div class="flex items-center gap-2 mb-4">
      <span class="text-dark-blue font-semibold text-[16px]">{{ $t("city.locationType") }}</span>
      <span class="cursor-pointer text-secondary-2">
        <IconsCIconE width="14" height="14" @click="showNurseStationInfoModel = true" />
      </span>
    </div>

    <div class="flex gap-4 items-center">
      <button
        @click="setClinicTypeFilter('clinic')"
        class="flex items-center justify-center gap-2 px-3 h-[30px] rounded-[5px] border transition-all w-fit"
        :class="
          selectedTypes.includes('clinic')
            ? 'border-secondary-2 bg-white text-secondary-2'
            : 'border-dark-gray bg-white text-slate-grey'
        "
      >
        <span class="flex items-center">
          <IconsMarkerPin :color="selectedTypes.includes('clinic') ? '#991e66' : '#6D7278'" width="12" height="16" />
        </span>
        <span class="font-semibold text-base leading-none whitespace-nowrap">{{ $t("city.clinic") }}</span>
      </button>

      <button
        @click="setClinicTypeFilter('nurse-station')"
        class="flex items-center justify-center gap-2 px-3 h-[30px] rounded-[5px] border transition-all w-fit"
        :class="
          selectedTypes.includes('nurse-station')
            ? 'border-secondary-2 bg-white text-secondary-2'
            : 'border-dark-gray bg-white text-slate-grey'
        "
      >
        <span class="flex items-center">
          <IconsMarkerPin
            :color="selectedTypes.includes('nurse-station') ? '#00a1aa' : '#6D7278'"
            width="12"
            height="16"
          />
        </span>
        <span class="font-semibold text-base leading-none whitespace-nowrap">{{ $t("city.nurseStation") }}</span>
      </button>
    </div>

    <ClinicNurseStationInfoModel :show="showNurseStationInfoModel" @close="showNurseStationInfoModel = false" />
  </div>
</template>

<script setup lang="ts">
const selectedTypes = ref<string[]>(["clinic", "nurse-station"]);

const showNurseStationInfoModel = ref(false);

const emit = defineEmits(["clinicTypeChanged"]);

function setClinicTypeFilter(type: string) {
  if (selectedTypes.value.includes(type)) {
    selectedTypes.value = selectedTypes.value.filter((t) => t !== type);
  } else {
    selectedTypes.value = [...selectedTypes.value, type];
  }

  emit("clinicTypeChanged", selectedTypes.value);
}
</script>
